<div>
  <div
    *ngIf="app.filterList.field !== null"
    class="col-md-8 no-padding pb-3 fa-pull-right"
  >
    <div *ngIf="getFieldType(app.filterList.field) == 'options'">
      <div class="box">
        <button
          class="btn btn-sm selected selectedFilter"
          (click)="app.filterList.field = null; app.filterList.open = true; optionSearchTerm = ''"
          *ngIf="app.filterList.field != null"
          type="button"
        >
          {{ app.field.getLabel(app.filterList.field) }}
          <i class="fa fa-times app-subtle"></i>
        </button>
        <div class="dropdown">
          <input
            class="form-control dropdown-filter dropdown-toggle"
            data-bs-toggle="dropdown"
            [(ngModel)]="optionSearchTerm"
            (click)="app.filterTable.isDropdownOpen = true"
          />
          <button
            *ngIf="
              app.filter.isSelected(app.filterList.field, getActiveFilters())
            "
            class="btn clear-dropdown"
          >
            <i
              class="fa fa-times icon-size"
              (click)="clearFilter(app.filterList.field)"
            ></i>
          </button>

          <div class="dropdown-menu dropdown-list">
            <div *ngFor="let option of getFilteredCurrentOptions()">
              <!-- <label class="checkbox-label" (click)="$event.stopPropagation()"> -->
              <div
                class="filter-row"
                [class.selected]="
                  app.filter.isChecked(
                    app.filterList.field,
                    option,
                    getActiveFilters()
                  )
                "
                (click)="selectOption(app.filterList.field, option)"
              >
                <span class="label">
                  {{
                    app.filterTree.getOptionText(app.filterList.field, option)
                  }}
                </span>
              </div>

              <!-- </label> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="getFieldType(app.filterList.field) == 'user-options'">
      <div class="box">
        <button
          class="btn btn-sm selected selectedFilter"
          (click)="app.filterList.field = null; app.filterList.open = true; optionSearchTerm = ''"
          *ngIf="app.filterList.field != null"
          type="button"
        >
          {{ app.field.getLabel(app.filterList.field) }}
          <i class="fa fa-times app-subtle"></i>
        </button>
        <div class="dropdown">
          <input
            class="form-control dropdown-filter dropdown-toggle"
            data-bs-toggle="dropdown"
            [(ngModel)]="optionSearchTerm"
            (click)="app.filterTable.isDropdownOpen = true"
          />
          <!-- <button
            *ngIf="
              app.filter.isSelected(
                app.filterList.field,
                app.filterHeaderTable.filters
              )
            "
            class="btn clear-dropdown"
          >
            {{ app.model | json }}
            <i
              class="fa fa-times icon-size"
              (click)="clearFilter(app.filterList.field)"
            ></i>
          </button> -->

          <div class="dropdown-menu dropdown-list">
            <div *ngFor="let option of getFilteredCurrentOptions()">
              <div
                *ngIf="option.name?.trim()"
                class="filter-row"
                [class.selected]="
                  app.filter.isChecked(
                    app.filterList.field,
                    option,
                    getActiveFilters()
                  )
                "
                (click)="selectOption(app.filterList.field, option.id)"
              >
                <span class="label">
                  {{ option.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="getFieldType(app.filterList.field) == 'dataList'">
      <div class="box">
        <button
          class="btn btn-sm selected selectedFilter"
          (click)="app.filterList.field = null; app.filterList.open = true; optionSearchTerm = ''"
          *ngIf="app.filterList.field != null"
          type="button"
        >
          {{ app.field.getLabel(app.filterList.field) }}
          <i class="fa fa-times app-subtle"></i>
        </button>
        <div class="dropdown">
          <input
            class="form-control dropdown-filter dropdown-toggle"
            data-bs-toggle="dropdown"
            [(ngModel)]="optionSearchTerm"
            (click)="app.filterTable.isDropdownOpen = true"
          />
          <button
            *ngIf="
              app.filter.isSelected(app.filterList.field, getActiveFilters())
            "
            class="btn clear-dropdown"
          >
            <i
              class="fa fa-times icon-size"
              (click)="clearFilter(app.filterList.field)"
            ></i>
          </button>
          <div class="dropdown-menu dropdown-list">
            <div *ngFor="let option of getFilteredCurrentOptions()">
              <div
                class="filter-row"
                [class.selected]="
                  app.filter.isChecked(
                    app.filterList.field,
                    option,
                    getActiveFilters()
                  )
                "
                (click)="selectOption(app.filterList.field, option)"
              >
                <span class="label">{{ option }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="getFieldType(app.filterList.field) == 'typeahead'">
      <app-field
        [model]="app.model"
        [field]="app.filterList.field"
        [differentDisplay]="true"
        [showLabel]="false"
        [typeaheadPlaceholder]="'Search'"
      >
      </app-field>
    </div>
  </div>
  <div *ngIf="getFilterFields()">
    <div *ngFor="let filter of app.state.filterByPage">
      <button
        *ngIf="
          filter.filterLabelField &&
          !app.filterFields.isQuickFilterField(filter.filterLabelField)
        "
        (click)="clearFilter(filter.filterLabelField); $event.stopPropagation()"
        class="button btn p-0 pb-3 m-0 pull-right"
        [ngbTooltip]="app.text.filter.remove"
      >
        <span class="badge badge-pill badge-om p-2">
          {{ app.field.getLabel(filter.filterLabelField) }} : &nbsp;
          {{
            getDisplayValue(filter.filterLabelField, filter.values) | uppercase
          }}
          &nbsp;
          <i class="far fa-times-circle"></i>
        </span>
      </button>
    </div>
  </div>
</div>
